var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-popover", {
    attrs: { placement: "bottom-start", trigger: "click" },
    on: { show: _vm.handleShow },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "multipleTable",
                  staticClass: "mb-10",
                  staticStyle: { "max-width": "95vw" },
                  attrs: { data: _vm.data, "row-key": "code" },
                },
                [
                  _vm._l(_vm.filedList, function (item, index) {
                    return _c(
                      "el-table-column",
                      _vm._b(
                        {
                          key: index,
                          attrs: { property: item.code, label: item.name },
                        },
                        "el-table-column",
                        item.config,
                        false
                      )
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "120",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-popover", {
                              attrs: { placement: "left", width: "1020" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c(
                                          "el-descriptions",
                                          {
                                            attrs: {
                                              title: "处方详情",
                                              column: 4,
                                              border: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "extra",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleRowClick(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("选择")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "el-descriptions-item",
                                              {
                                                attrs: {
                                                  span: 2,
                                                  label: "名称",
                                                },
                                              },
                                              [_vm._v(_vm._s(scope.row.name))]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              {
                                                attrs: {
                                                  span: 2,
                                                  label: "方剂出处",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.prescriptionSource
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              {
                                                attrs: {
                                                  span: 4,
                                                  label: "方剂内容",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .prescriptionContent
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              {
                                                attrs: {
                                                  span: 4,
                                                  label: "方剂说明",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .prescriptionDescribe
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              { attrs: { label: "用药天数" } },
                                              [_vm._v(_vm._s(scope.row.dayNum))]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              { attrs: { label: "每日剂数" } },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.dayDoseNum)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              { attrs: { label: "每日次数" } },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.dayFreq)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              { attrs: { label: "剂数" } },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.doseNum)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-descriptions-item",
                                              { attrs: { label: "代加工" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("DecoctSignType")(
                                                      scope.row.decoctSign
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "reference",
                                    fn: function () {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                          },
                                          [_vm._v("详情")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRowClick(scope.row)
                                  },
                                },
                              },
                              [_vm._v("选择")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "reference",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  staticClass: "ik-user-btn",
                  attrs: { size: "mini", type: "primary" },
                },
                [_vm._t("default")],
                2
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.visiable,
      callback: function ($$v) {
        _vm.visiable = $$v
      },
      expression: "visiable",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }